<div class="app-main-wrapper">
  <ima-translation-status-banner class="app-diagnostics" />

  <ima-main-header class="app-main-header" />
  <ima-main-nav class="app-main-nav" [collapseTextOnly]="collapseNavTextOnly" />

  <div class="content-wrapper">
    <div class="content-main">
      <router-outlet></router-outlet>
    </div>

    <ima-main-footer class="app-main-footer" />
  </div>
</div>

<ima-fatal-error-overlay />
